import { render, staticRenderFns } from "./InventoryOnHandKartuStock.vue?vue&type=template&id=2827ae7a&"
import script from "./InventoryOnHandKartuStock.vue?vue&type=script&lang=js&"
export * from "./InventoryOnHandKartuStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports